import React, { useContext } from "react";

import { Icon } from "components/Icon";
import { useIntl } from "react-intl";
import styled from "styled-components";

import { REGISTRATION_GET_COUNT_API } from "const/apiMethods";
import { checkPermissionsFor } from "store/storeHelpers";
import { APP_TYPE_ADMIN } from "const";
import m from "definedMessages";
import { ServiceLink } from "components/Navigation/ServiceLink";
import { AppTypeContext } from "../../../App";
import * as S from "../styled.js";


import { useLocation } from "react-router-dom";
import { Badge, Dropdown } from "rsuite";

export default ({
    rtl,
    data = [],
    logoutUser,
    registrationCount,
    ...props
}) => {

    const { formatMessage } = useIntl();
    const location = useLocation();
    const appType = useContext(AppTypeContext);

    return (
        <StyledDropdown
            activeKey={location.pathname}
            icon={<Icon icon="bars" />}
            title={formatMessage(m.menu)}
            {...props}
        >
            {data.map((item, index) => {
                const itemKey = item.key || `menu-${index}-${item.title}`;

                if (item.children && !item.children.length) {
                    return null;
                }

                if (item.children && item.children.length) {
                    return (
                        <Dropdown.Menu
                            key={itemKey}
                            title={item.title}
                            data-direction={rtl ? "end" : "start"}
                        >
                            {item.children.map(child => (
                                <Dropdown.Item
                                    key={child.key}
                                    as={ServiceLink}
                                    to={child.key}
                                    eventKey={child.key}
                                    onClick={child.onClick || null}
                                >
                                    {child.title}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    )
                }

                return item.onClick
                    ? <Dropdown.Item as={ServiceLink} key={itemKey} to={item.key} onClick={item.onClick} eventKey={item.key}>
                        {item.title}
                    </Dropdown.Item>
                    : <Dropdown.Item as={ServiceLink} key={itemKey} to={item.key} eventKey={item.key}>
                        {item.title}
                    </Dropdown.Item>
            })}

            <Dropdown.Item divider />

            {checkPermissionsFor(REGISTRATION_GET_COUNT_API) && appType === APP_TYPE_ADMIN &&
                <Dropdown.Item as={ServiceLink} to="/registration-requests" eventKey="/registration-requests">
                    <Badge content={registrationCount}><Icon icon="group" /></Badge>
                </Dropdown.Item>
            }

            <Dropdown.Item as={ServiceLink} onClick={logoutUser} to="/login" eventKey="/login">
                <Icon icon="sign-out" /> {formatMessage(m.unlogin)}
            </Dropdown.Item>
        </StyledDropdown>
    )
};


const StyledDropdown = styled(S.StyledDropdown).attrs(() => {
    return {
        noCaret: true,
        className: "custom-dropdown-menu appMenu",
        menuStyle: { borderTopLeftRadius: 0, borderTopRightRadius: 0 },
        toggleClassName: "custom-dropdown-menu-toggle",
        placement: "bottomEnd"
    }
})`
    &&&&&& .rs-dropdown-toggle {
        .app-client & {
            background-color: transparent !important;
        }
    }
`;
